import React from 'react';
import { Routes } from 'react-router-dom';

import { contactRoutes } from './contactRoutes';
import { fileStoreRoutes } from './fileStoreRoutes';
import { authRoutes } from './authRoutes';
import { dashboardRoutes } from "./dashboardRoutes";
import { ledgerRoutes } from './ledgerRoutes';

export const AppRoutes = () => {
    return (
        <Routes>
            {authRoutes}
            {dashboardRoutes}
            {contactRoutes}
            {fileStoreRoutes}
            {ledgerRoutes}
        </Routes>
    );
};
